import { render, staticRenderFns } from "./AgentManufacturerSelect.vue?vue&type=template&id=4331f19b"
import script from "./AgentManufacturerSelect.vue?vue&type=script&lang=ts"
export * from "./AgentManufacturerSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports